import { useClientContext } from "@hooks/index";
import { useQuery } from "@tanstack/react-query";
import { getGantt } from "./index";

export const useGetGantt = (date: Date, enabled = true) => {
  const customFetch = useClientContext();

  return useQuery({
    queryKey: ["timeline", "gantt", date],
    retry: false,
    refetchInterval: 20000,
    refetchIntervalInBackground: true,
    queryFn: () => getGantt(customFetch)(date),
    enabled: Boolean(date) && enabled,
  });
};
